export default "__VITE_ASSET__CWuYnpNt__"